import { compare, hash } from "bcrypt";
import { sign, verify } from "jsonwebtoken";

// import HajarError from "../utils/hajarError";

export async function login(
  email: string,
  password: string,
  userType: string,
  config: any
) {
  try {
    const { models } = config.mongoose;
    const user = await models.User.findOne({ email });
    if (!user) {
      throw new Error("User not found");
      //   throw new HajarError("User not found", "invalid-email-password");
    }

    const validPassword = await compare(password, user.password);

    if (!validPassword) {
      throw new Error("User not found");

      //   throw new HajarError("Invalid password", "invalid-email-password");
    }

    // Capitalize the first letter of userType
    const modelType = userType.charAt(0).toUpperCase() + userType.slice(1);

    // Check if the model exists in models on our mongoose instance
    if (!models[modelType]) {
      throw new Error("User not found");

      //   throw new HajarError("Invalid user type", "invalid_user_type");
    }

    const additionalData = await models[modelType].findOne({ uid: user._id });
    if (!additionalData) {
      throw new Error("User not found");

      //   throw new HajarError(`${modelType} not found`, `${userType}_not_found`);
    }

    const token = sign({ _id: user._id }, config.accessToken, {
      expiresIn: "1h"
    });

    const refreshToken = sign({ _id: user._id }, config.refreshToken, {
      expiresIn: "7d"
    });

    return {
      success: true,
      user: { ...user.toObject() },
      [userType]: { ...additionalData.toObject() },
      token,
      refreshToken
    };
  } catch (error) {
    console.error("Login error:", error);
    throw error;
  }
}
